// this is an autogenerated file from DesignSystem/TasksBoardsList/Boards/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_TasksBoardsList_Boards($location_id: uuid!, $boards_where: tasks_boards_bool_exp!) {
  tasks_boards(
    where: {
      status: { _eq: active }
      metadata: { _contains: { locations: [$location_id] } }
      _and: [$boards_where]
    }
    order_by: { name: asc }
  ) {
    id
    name
    metadata

    stages(order_by: [{ order: asc }], limit: 1) {
      id
      tasks_aggregate {
        aggregate {
          count
        }
      }
    }
  }
}

`